<template>
	<div class="clearfix">
		<!-- 移除隐藏的 input，由父级表单控制 -->
		<a-upload :customRequest="handleUpload" list-type="picture-card" :file-list="fileList" :multiple="multiple"
			:beforeUpload="beforeUpload" @change="handleChange" @preview="handlePreview" @remove="handleRemove"
			accept="image/*">
			<div v-if="fileList.length < maxCount">
				<a-icon type="plus" />
				<div class="ant-upload-text">上传图片</div>
			</div>
		</a-upload>

		<a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
			<img alt="预览图片" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	function getBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = error => reject(error);
		});
	}

	import {
		uploadImage
	} from '@/api/app';

	export default {
		name: 'ImageUpload',
		props: {
			// 移除 value 和 rules 的 props，由 v-decorator 控制
			multiple: {
				type: Boolean,
				default: true
			},
			maxCount: {
				type: Number,
				default: 9
			},
			maxSize: {
				type: Number,
				default: 5 // MB
			}
		},
		data() {
			return {
				fileList: [],
				previewVisible: false,
				previewImage: ''
			};
		},
		methods: {
			beforeUpload(file) {
				const isImage = file.type.startsWith('image/');
				if (!isImage) {
					this.$message.error('只能上传图片文件!');
					return false;
				}

				const isLtSize = file.size / 1024 / 1024 < this.maxSize;
				if (!isLtSize) {
					this.$message.error(`图片大小不能超过${this.maxSize}MB!`);
					return false;
				}

				if (this.fileList.length >= this.maxCount) {
					this.$message.error(`最多只能上传${this.maxCount}张图片!`);
					return false;
				}

				return true;
			},

			handleUpload({
				file,
				onProgress,
				onSuccess,
				onError
			}) {
				const formData = new FormData();
				formData.append('xupload', file);

				if (!file.uid) {
					file.uid = `photo-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`;
				}

				uploadImage(formData, {
					onUploadProgress: (progressEvent) => {
						const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						onProgress({
							percent
						}, file);
					}
				}).then(response => {
					if (response.isSucceed) {
						onSuccess({
							...response,
							data: {
								...response.data,
								url: response.data.url
							}
						}, file);
					} else {
						onError(new Error(response.message || '上传失败'), file);
					}
				}).catch(error => {
					onError(error, file);
				});
			},

			handleChange({
				fileList
			}) {
				this.fileList = fileList.map(f => {
					if (f.status === 'done' && f.response?.data?.url) {
						return {
							...f,
							uid: f.uid,
							url: f.response.data.url,
							name: f.name || `photo-${Date.now()}.jpg`
						};
					}
					if (f.status === 'uploading') {
						return {
							...f,
							uid: f.uid,
							name: f.name
						};
					}
					return f;
				}).filter(f => f.status !== 'error');

				// 只触发 change 事件，不直接修改值
				const uploadedUrls = this.fileList
					.filter(f => f.status === 'done' && f.url)
					.map(f => f.url)
					.join(',');

				this.$emit('change', uploadedUrls);
			},

			async handlePreview(file) {
				if (file.url) {
					this.previewImage = file.url;
					this.previewVisible = true;
					return;
				}

				if (file.originFileObj) {
					try {
						const preview = await getBase64(file.originFileObj);
						this.previewImage = preview;
						this.previewVisible = true;
					} catch (error) {
						this.$message.error('图片预览生成失败');
					}
					return;
				}

				this.$message.warning('无法预览该图片');
			},

			handleRemove(file) {
				return new Promise((resolve) => {
					this.$confirm({
						title: '确认删除',
						content: '确定要删除这张图片吗？',
						onOk: () => {
							const newFileList = this.fileList.filter(f => f.uid !== file.uid);
							this.fileList = newFileList;

							const uploadedUrls = newFileList
								.filter(f => f.status === 'done' && f.url)
								.map(f => f.url)
								.join(',');

							this.$emit('change', uploadedUrls);
							resolve(true);
						},
						onCancel: () => resolve(false)
					});
				});
			},
			clearFiles() {
				this.fileList = [];
				this.$emit('change', '');
			},
		}
	};
</script>